export class GroupDetailsDto {
  constructor(public readonly groupName: string,
    public readonly address: string,
    public readonly isLocationAssigned: boolean,
    public readonly coordinate: Array<number>) { }
}
